operations:
  load-models: Tải các mô hình
  load-models-status:
    loading: Đang tải
    ready: Sẵn sàng
docs:
  theme:
    navbar:
      appearance:
        title: Giao diện
'controls-island':
  'fade-on-hover':
    enable: Ẩn khi rê chuột
    disable: Luôn hiển thị
  'open-settings': Mở cài đặt
  'open-chat': Mở trò chuyện
  'refresh': Làm mới
  'center-main-window': Move to screen center
  'open-hearing-controls': Kiểm soát thính giác mở
  'drag-to-move-window': Kéo để di chuyển cửa sổ
  'switch-to-light-mode': Chuyển sang chế độ sáng
  'switch-to-dark-mode': Chuyển sang chế độ tối
  'pin-on-top': Ghim lên trên
  'unpin-from-top': Gỡ ghim khỏi đầu trang
  'switch-profile': Chuyển Hồ Sơ
  'close': Đóng
  'expand': Mở rộng
  'collapse': Sụp đổ
  'login': Đăng nhập
  'logging-in': Đang đăng nhập...
  'account': Tài khoản
  'logout': Đăng xuất
widgets:
  close: Đóng tiện ích
  empty:
    title: Không có tiện ích hoạt động
    description: Widgets will appear here when a tool or plugin spawns one.
  loading: Đang tải tiện ích…
  waiting: Đang đợi dữ liệu tiện ích cho "{id}"…
notice:
  'fade-on-hover':
    title: Mờ dần khi rê chuột
    intro: Tự làm mờ nhân vật khi con trỏ ở gần. Giảm xao nhãng nhưng vẫn nhìn thấy nhân vật.
    opacity: Bật lên thì độ mờ giảm xuống {value} cho {targets} khi con trỏ ở gần.
    toggle: Tắt đi bằng cách rê chuột qua {controls} rồi bấm lại {icon}.
    controls-label: Đảo Điều Khiển
    icon-label: biểu tượng mắt gạch
    value: '0'
    targets: Nhân vật và giao diện
    confirm: Đã hiểu
    dont-show-again: Đừng hiển thị lại
    preparing: Đang chuẩn bị…
    read-more: Xem thêm
    preview-title: Đây là gì?
about:
  subtitle: Desktop ver.
  current-version: Phiên Bản Hiện Tại
  common:
    cancel: Hủy
  links:
    title: Các Liên Kết
    home: Trang chủ
    documentation: Tài liệu
    github: GitHub
  update:
    lane:
      label: Update lane
      description: Choose channel release to follow
      placeholder: Choose update lane
    channels:
      auto: Tự động
      stable: Ổn định
      alpha: Alpha
      beta: Beta
      nightly: Nightly
      canary: Canary
    status:
      downloading: Đang tải bản cập nhật...
      error-prefix: Lỗi
      latest: Bản mới nhất (v{version}).
      downloaded:
        windows: Bản cập nhật sẵn sàng để tải trong im lặng (v{version}).
        restart: Bản cập nhật sẵn sàng để tải khi khởi động lại (v{version}).
    actions:
      download: Tải Bản Cập Nhật
      download-short: Tải
      confirm-download: Xác Nhận Tải
      check-for-updates: Kiểm tra bản cập nhật
      checking: Đang kiểm tra...
      latest-version: Phiên bản mới nhất
      disabled-dev: Các bản cập nhật bị vô hiệu trong Dev
      retry-check: Retry Check
      restart-silent: Khởi động lại để cập nhật trong im lặng
      restart-install: Khởi động lại để tải bản cập nhật
      confirm-restart: Xác Nhận Khởi Động Lại
    dialog:
      title: Có Bản Cập Nhật Mới
      description: Hiện đang có phiên bản mới (v{version}).
      no-release-notes-markdown: _No release notes provided._
